<ng-container [ngSwitch]="ctaData.url" *ngIf="ctaData">
    <div class="hero-cta-action" *ngSwitchCase="false">
        <a class="{{ctaClass}}"
            finderLinkId
            tabindex="0"
            [ngClass]="{'hero-shadow': ctaData.shadowEnabled}"
            [attr.alt]="ctaData.alt"
            target="{{ctaData.target}}"
            attr.aria-label="{{ctaData.title}}"
            (click)="anchorClick($event)"
            (keydown.enter)="anchorClick($event)"
            role="button"
        >
            <span class="cta-title">{{ctaData.title}}</span>
            <finder-font-icon
                *ngIf="ctaData.icon"
                htmlEntity="{{ctaData.icon.icon}}"
                size="{{ctaData.icon.size}}"
                title="{{ctaData.icon.alt}}"
                aria-hidden="true"
            ></finder-font-icon>
        </a>
    </div>
    <div class="hero-cta-action" *ngSwitchDefault>
        <a class="{{ctaClass}}"
            finderLinkId
            [ngClass]="{'hero-shadow': ctaData.shadowEnabled}"
            [attr.alt]="ctaData.alt"
            [href]="ctaData.url"
            target="{{ctaData.target}}"
            attr.aria-label="{{ctaData.title}}"
        >
            <span class="cta-title">{{ctaData.title}}</span>
            <finder-font-icon
                *ngIf="ctaData.icon"
                htmlEntity="{{ctaData.icon.icon}}"
                size="{{ctaData.icon.size}}"
                title="{{ctaData.icon.alt}}"
                aria-hidden="true"
            ></finder-font-icon>
        </a>
    </div>
</ng-container>
